module.exports = __webpack_public_path__ + "static/media/allam_iqbal_pic.88e79c9e.jpg";